import { useNavigate, useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import axiosClient from "../../axiosClient";
import { Loader } from "rsuite";
import { Question } from "../../types";
import ReadOnlyQuestionsView from "../Shared/ReadOnlyQuestionsView";

const SubmissionPage = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [questions, setQuestions] = useState<Question[]>([]);
  const navigate = useNavigate();

  let { submissionId } = useParams();

  useEffect(() => {
    const getQuestions = async () => {
      try {
        const submissionResp: {
          id: number;
          submittedDate: string;
          assignmentId: number;
          assignment: {
            name: string
          };
          studentId: number;
          score: number;
          questions: Question[];
        } = (await axiosClient.get("/submissions/" + submissionId))
            .data;
  
        const submissionAnswers = {};
        submissionResp.questions.forEach((question) => {
          let submissionAnswer;
  
          submissionAnswer = question.answerOptions.filter(
            (answerOption) => answerOption.selected,
          );
  
          if (submissionAnswer.length) {
            (submissionAnswers as any)[question.id] =
              submissionAnswer[0].id;
          }
        });
        setQuestions(submissionResp.questions);
        setIsLoading(false);
      }

      catch (error) {
        navigate('/dashboard')
      }
    }

    getQuestions();
  }, [navigate, submissionId])
  
  if (isLoading) {
    return <Loader size="md" content="Loading..." style={{ margin: "auto" }} />;
  }

  return (
    <ReadOnlyQuestionsView
      questions={questions}
      pageId="SubmissionPage"
      onQuestionsUpdate={setQuestions}
    />
  );
};

export default SubmissionPage;
